import {CommonModule}                                              from '@angular/common';
import {booleanAttribute, Component, ElementRef, input, ViewChild} from '@angular/core';
import {ChartConfiguration}                                        from 'chart.js';
import {ChartCompBase}                                             from '../../tools/chart-comp.base';


@Component({
			   selector   : 'lib-chart-bar',
			   imports    : [
				   CommonModule
			   ],
			   templateUrl: './chart-bar.component.html',
			   styleUrl: './chart-bar.component.css'
		   })
export class ChartBarComponent extends ChartCompBase<'bar' | 'line', any> {
	@ViewChild('ChartItem') chartItem!: ElementRef<HTMLCanvasElement>;
	@ViewChild('LegendWrapper') legendWrapper!: ElementRef<HTMLDivElement>;
	chartConf = input.required<ChartConfiguration<'bar' | 'line'>>();
	disableLegend = input(booleanAttribute(false), {transform: booleanAttribute});
}
